import * as React from "react"

import { cn } from "@/lib/utils"

/**
 * Jackstone badge system.
 *   tone : jackstone-blue | navy | red | blue | green | teal | purple | grey
 *   fill : soft | solid
 *   shape: rounded | pill
 *
 * Semantic guidance:
 *   green  → do / use / positive            red    → don't / avoid / alert
 *   teal   → fresh / secondary timeline      purple → premium / strategic
 *   grey   → neutral category labels         blue   → interactive / bright
 *
 * Colour rules live in index.css (.badge-<tone>-<fill>) and are all
 * contrast-checked against WCAG AA. Any utility passed via className
 * (e.g. severity colours) overrides the tone, because utilities sit in a
 * later cascade layer than the component classes.
 */
const TONE_CLASS = {
  "jackstone-blue": { soft: "badge-jackstone-blue-soft", solid: "badge-jackstone-blue-solid" },
  navy:   { soft: "badge-navy-soft",   solid: "badge-navy-solid" },
  red:    { soft: "badge-red-soft",    solid: "badge-red-solid" },
  blue:   { soft: "badge-blue-soft",   solid: "badge-blue-solid" },
  green:  { soft: "badge-green-soft",  solid: "badge-green-solid" },
  teal:   { soft: "badge-teal-soft",   solid: "badge-teal-solid" },
  purple: { soft: "badge-purple-soft", solid: "badge-purple-solid" },
  grey:   { soft: "badge-grey-soft",   solid: "badge-grey-solid" },
}

function Badge({ className, tone = "jackstone-blue", fill = "solid", shape = "rounded", ...props }) {
  const toneSet = TONE_CLASS[tone] || TONE_CLASS["jackstone-blue"]
  const toneClass = toneSet[fill] || toneSet.solid
  return (
    <div
      className={cn(
        "inline-flex items-center border px-2.5 py-0.5 text-xs font-semibold transition-colors",
        shape === "pill" ? "rounded-full" : "rounded-md",
        toneClass,
        className
      )}
      {...props}
    />
  )
}

export { Badge }
